import actionTypes from '../actions/actionTypes'

const defaultState = {
	id: 0,
	entityUID: 0,
	promoted: [],
}

function updateEntityID(state, action) {
	const newState = {
		...state,
		id: action.id,
	}
	return newState
}

function previewDataFetched(state, action) {

	const newState = {
		...state,
		entityUID: action.response.result.data.entityUID,
		promoted: action.response.promoted.map(promotedGroup => ({
			...promotedGroup,
			entities: promotedGroup.entities.map(item => item.data.entityUID),
		})),
	}

	return newState
}

function clearLessonData() {
	return defaultState
}

const myLibraryReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MY_LIBRARY_PREVIEW_INITIALIZE:
		case actionTypes.MY_LIBRARY_PREVIEW_UPDATE:
			return updateEntityID(state, action)
		case actionTypes.MY_LIBRARY_PREVIEW_DATA_FETCHED:
			return previewDataFetched(state, action)
		case actionTypes.MY_LIBRARY_PREVIEW_EXIT:
			return clearLessonData(state)
		default:
			return state
	}
}

export default myLibraryReducer
